import { navigate } from "../router";

export default function PublicHome() {
  return (
    <div style={{ maxWidth: 500, margin: "0 auto", padding: "80px 24px", textAlign: "center" }}>
      <div style={{ fontSize: 56, marginBottom: 24 }}>🥊</div>
      <h1 style={{ fontFamily: "var(--font-display)", fontSize: 36, color: "#fff", letterSpacing: 2, marginBottom: 12 }}>
        ANCHORPOINT SETUP
      </h1>
      <p style={{ color: "#555", fontSize: 14, lineHeight: 1.7, marginBottom: 32 }}>
        ¿Tienes el link del evento? Accede desde ahí para anotar lo que vas a traer.
      </p>
      <p style={{ color: "#333", fontSize: 12 }}>
        Si eres organizador, accede al{" "}
        <button
          onClick={() => navigate("#/admin")}
          style={{ background: "none", border: "none", color: "#cc2200", cursor: "pointer", fontSize: 12, textDecoration: "underline" }}
        >
          panel de administración
        </button>
      </p>
    </div>
  );
}
